// ─── Helpers ──────────────────────────────────────────────────────────────────

export function parsePatch(patch: string | null): { original: string; modified: string } | null {
  if (!patch) return null;
  const original: string[] = [];
  const modified: string[] = [];
  for (const raw of patch.split("\n")) {
    if (
      raw.startsWith("@@") || raw.startsWith("diff ") ||
      raw.startsWith("index ") || raw.startsWith("--- ") ||
      raw.startsWith("+++ ") || raw.startsWith("\\")
    ) continue;
    if (raw.startsWith("-")) { original.push(raw.slice(1)); }
    else if (raw.startsWith("+")) { modified.push(raw.slice(1)); }
    else { const l = raw.startsWith(" ") ? raw.slice(1) : raw; original.push(l); modified.push(l); }
  }
  return { original: original.join("\n"), modified: modified.join("\n") };
}

export function detectLanguage(filename: string): string {
  const lower = filename.toLowerCase();
  if (lower.endsWith(".cls") || lower.endsWith(".trigger") || lower.endsWith(".apex")) return "apex";
  const ext = lower.split(".").pop() ?? "";
  const map: Record<string, string> = {
    ts: "typescript", tsx: "typescript", js: "javascript", jsx: "javascript",
    mjs: "javascript", cjs: "javascript", py: "python", rb: "ruby",
    java: "java", go: "go", rs: "rust", php: "php", cs: "csharp",
    cpp: "cpp", c: "cpp", xml: "xml", json: "json",
    yaml: "yaml", yml: "yaml", md: "markdown", html: "html",
    css: "css", scss: "css", less: "css", sh: "shell", bash: "shell",
    sql: "sql", tf: "hcl", hcl: "hcl", toml: "ini", ini: "ini",
  };
  return map[ext] ?? "plaintext";
}

export function statusLabel(status: string): { letter: string; color: string } {
  const map: Record<string, { letter: string; color: string }> = {
    added:    { letter: "A", color: "text-green-500 bg-green-500/10" },
    removed:  { letter: "D", color: "text-red-500 bg-red-500/10" },
    modified: { letter: "M", color: "text-blue-400 bg-blue-500/10" },
    renamed:  { letter: "R", color: "text-purple-400 bg-purple-500/10" },
    copied:   { letter: "C", color: "text-purple-400 bg-purple-500/10" },
  };
  return map[status] ?? { letter: status.charAt(0).toUpperCase(), color: "text-muted-foreground bg-muted" };
}
